import { ElementRef, TemplateRef } from '@angular/core';

export type GasTabsType = 'default' | 'scoped';

export interface Tab {
  title:  string;
  active: boolean;
  content: string | TemplateRef<ElementRef>;
  id: string;
};
